var Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    getId: function() {
        return this.get('id');
    },
    getType: function() {
        return this.get('type');
    },
    getIcon: function() {
        return this.icon;
    },
    getTitle: function() {
        var name = this.get('name');
        return name ? name : ''; //would latter occur?
    },
    getFriendlyTitle: function() {
        return this.desc;
    },
    // Fields is only defined for File Cabinets, not Bins
    getFields: function() {
        return this.get('fields');
    },
    hasFields: function() {
        var flds = this.getFields();
        return flds && flds.length > 0;
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/container/container.js
 ** module id = 395
 ** module chunks = 0
 **/